import _ from "lodash";

export function truncate(text?: string) {
  return _.truncate(text ?? "", { length: 45 });
}

export function formatNotaryData(name?: string, number?: number) {
  return `${name} (${_.padStart(number?.toString(), 3, "0")})`;
}

export function translate(value: boolean) {
  return value ? "Да" : "Не";
}
